
import { z } from "zod";

export const FundingMilestoneScheduleValues = ["DEFAULT", "R1_REINSTALL", "R1_REMOVAL", "R2", "R2_V2", "R3", "R3_V2", "ROOF_REINSTALL", "ROOF_WORK"] as const;
export const FundingMilestoneScheduleSchema = /* @__PURE__ */ z.enum(FundingMilestoneScheduleValues);
export const FundingMilestoneSchedule: (typeof FundingMilestoneScheduleSchema)["enum"] = { "DEFAULT": "DEFAULT", "R1_REINSTALL": "R1_REINSTALL", "R1_REMOVAL": "R1_REMOVAL", "R2": "R2", "R2_V2": "R2_V2", "R3": "R3", "R3_V2": "R3_V2", "ROOF_REINSTALL": "ROOF_REINSTALL", "ROOF_WORK": "ROOF_WORK" };
export type FundingMilestoneSchedule = (typeof FundingMilestoneScheduleValues)[number];
export const FundingMilestoneScheduleDisplayNames = { "DEFAULT": "Default",
"R1_REINSTALL": "R1 Reinstall",
"R1_REMOVAL": "R1 Removal",
"R2": "R2",
"R2_V2": "R2 v2",
"R3": "R3",
"R3_V2": "R3 v2",
"ROOF_REINSTALL": "Roof Reinstall",
"ROOF_WORK": "Roof Work", } satisfies Record<FundingMilestoneSchedule, string>;
